<template>
    <div id="app" :class="'page-' + $router.currentRoute.name.toLowerCase()">
        
        <div id="wrapper" class="">
            <router-view :key="$route.fullPath"/>
        </div>
    </div>
</template>

<script>

export default {
    name: 'App',
    components: {
      
    },
    methods: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }    	
    }
}
</script>

<style>

#app {


}
</style>



// WEBPACK FOOTER //
// src/App.vue